import { EndpointFunctionEntity } from '@vlaio/shared/endpoints';

export const SelfRegistrationApplicationEndpoints: Record<string, EndpointFunctionEntity> = {
	Create: () => 'mandaten/mandaatuitvoerders/aanvragen'
};
